import { render, staticRenderFns } from "./CaseManageView2.vue?vue&type=template&id=434f87e8&scoped=true&"
import script from "./CaseManageView2.vue?vue&type=script&lang=js&"
export * from "./CaseManageView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f87e8",
  null
  
)

export default component.exports